import types from "../types";

const initialState = {
  features: {},
  isLoading: true,
};

export const homeFeatureActivityReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case types.SET_HOME_FEATURE_ACTIVITY:
      return {
        ...state,
        features: payload || {},
        isLoading: false,
      };
    case types.GLOBAL_RESET_STATE:
      return initialState;
    default:
      return state;
  }
};
